export const profitPlatforms = ["amazon", "tiktok"] as const;
export type ProfitPlatform = (typeof profitPlatforms)[number];

export const profitModes = ["estimated", "actual", "variance"] as const;
export type ProfitMode = (typeof profitModes)[number];

export const orderChannels = ["store_organic", "store_ad", "creator_organic", "creator_paid"] as const;
export type OrderChannel = (typeof orderChannels)[number];

export const allocationBases = ["quantity", "weight", "volume", "sales"] as const;
export type AllocationBasis = (typeof allocationBases)[number];

export const returnOutcomes = ["not_returned", "returned_resellable", "returned_unsellable"] as const;
export type ReturnOutcome = (typeof returnOutcomes)[number];

export const recordCompleteness = ["complete", "incomplete", "partially_settled"] as const;
export type RecordCompleteness = (typeof recordCompleteness)[number];

export const profitFactCodes = [
  "gross_sales", "coupon_discount", "promotion_discount", "merchant_discount", "refund_amount",
  "buyer_shipping", "platform_subsidy", "other_compensation",
  "product_cost", "packaging_cost", "domestic_logistics", "headhaul", "tariff",
  "warehouse_inbound", "warehouse_operation", "last_mile", "fba_fulfillment",
  "amazon_commission", "tiktok_commission", "payment_fee", "creator_commission", "extra_commission",
  "coupon_fee", "deal_fee", "activity_fee",
  "amazon_ad", "tiktok_ad", "gmv_max", "creator_ad",
  "overseas_storage", "fba_storage", "long_term_storage", "return_loss", "removal_disposal",
  "monthly_subscription", "software_fee", "fx_loss", "other_expense",
  "sample_product_cost", "sample_shipping", "slot_fee",
  "product_cost_recovery", "commission_recovery", "creator_commission_recovery", "logistics_recovery"
] as const;
export type ProfitFactCode = (typeof profitFactCodes)[number];

export type MoneyAmount = {
  amountMinor: string;
  currency: string;
  cnyMinor: string | null;
  usdMinor: string | null;
  rateSource: string | null;
};

export type ProfitFilters = {
  platform?: ProfitPlatform;
  site?: string;
  storeId?: string;
  productId?: string;
  sku?: string;
  orderNo?: string;
  creator?: string;
  dateFrom?: string;
  dateTo?: string;
  channel?: OrderChannel;
  activity?: "all" | "activity" | "regular";
  mode?: ProfitMode;
  reportingCurrency?: "CNY" | "USD";
};

export const profitFactLabels: Record<ProfitFactCode, string> = {
  gross_sales: "商品成交金额",
  coupon_discount: "Coupon优惠折扣",
  promotion_discount: "促销折扣",
  merchant_discount: "商家折扣",
  refund_amount: "退款金额",
  buyer_shipping: "买家支付运费",
  platform_subsidy: "平台补贴",
  other_compensation: "其他平台补偿",
  product_cost: "产品采购成本",
  packaging_cost: "包装成本",
  domestic_logistics: "国内运输费用",
  headhaul: "头程物流费用",
  tariff: "关税及清关费用",
  warehouse_inbound: "海外仓入库费",
  warehouse_operation: "海外仓操作费",
  last_mile: "尾程配送费",
  fba_fulfillment: "FBA配送费",
  amazon_commission: "Amazon销售佣金",
  tiktok_commission: "TikTok平台佣金",
  payment_fee: "支付手续费",
  creator_commission: "达人佣金",
  extra_commission: "广告佣金及额外佣金",
  coupon_fee: "Coupon费用",
  deal_fee: "Deal及活动报名费",
  activity_fee: "平台活动费用",
  amazon_ad: "Amazon广告费",
  tiktok_ad: "TikTok广告费",
  gmv_max: "GMV Max广告费",
  creator_ad: "达人相关广告费",
  overseas_storage: "海外仓仓储费",
  fba_storage: "FBA仓储费",
  long_term_storage: "长期仓储费",
  return_loss: "退货及退款损失",
  removal_disposal: "移除弃置及赔偿差额",
  monthly_subscription: "平台月租",
  software_fee: "软件及公共费用",
  fx_loss: "汇率损益",
  other_expense: "其他费用",
  sample_product_cost: "送样产品成本",
  sample_shipping: "送样物流成本",
  slot_fee: "达人坑位费",
  product_cost_recovery: "可售退货产品成本冲回",
  commission_recovery: "平台佣金退回",
  creator_commission_recovery: "达人佣金退回",
  logistics_recovery: "物流费退回"
};
